// アコーディオン（開閉式パネル）
$(".accordion_item-q").click(function () {
  $(this).toggleClass("is-open");
  $(this).next().toggleClass("is-open");
  $(this).next().slideToggle("slow");
});
